<template>
  <span class="svg-ico-plus-circle">
    <svg v-if="isTwoTone" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" :fill="color"/>
      <path d="M16.2105 11.2105H12.7895V7.78947C12.7895 7.35789 12.4316 7 12 7C11.5684 7 11.2105 7.35789 11.2105 7.78947V11.2105H7.78947C7.35789 11.2105 7 11.5684 7 12C7 12.4316 7.35789 12.7895 7.78947 12.7895H11.2105V16.2105C11.2105 16.6421 11.5684 17 12 17C12.4316 17 12.7895 16.6421 12.7895 16.2105V12.7895H16.2105C16.6421 12.7895 17 12.4316 17 12C17 11.5684 16.6421 11.2105 16.2105 11.2105Z" :fill="color2"/>
    </svg>
    <svg v-else-if="isSolid" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.7895 11.2105H16.2105C16.6421 11.2105 17 11.5684 17 12C17 12.4316 16.6421 12.7895 16.2105 12.7895H12.7895V16.2105C12.7895 16.6421 12.4316 17 12 17C11.5684 17 11.2105 16.6421 11.2105 16.2105V12.7895H7.78947C7.35789 12.7895 7 12.4316 7 12C7 11.5684 7.35789 11.2105 7.78947 11.2105H11.2105V7.78947C11.2105 7.35789 11.5684 7 12 7C12.4316 7 12.7895 7.35789 12.7895 7.78947V11.2105Z" :fill="color"/>
    </svg>
    <svg v-else :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 12C21 16.9483 16.9483 21 12 21C7.05171 21 3 16.9483 3 12C3 7.05171 7.05171 3 12 3C16.9483 3 21 7.05171 21 12Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8 12H16" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 16V8" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
